module.exports = __webpack_public_path__ + "static/media/modal-close-icon.476ea775.svg";